import { Injectable } from '@angular/core';
import { CenterModel } from '@medindex-webapi';

import {
  placemarkCenterOptions,
  placemarkCenterOptionsLite,
} from '@shared/modules/map/constants/optionsMap';
import { MapService } from '@shared/modules/map/map.service';
import { IPlacemarkCenter } from '../types/promotion-map.types';

@Injectable()
export class PromotionMapService {
  constructor(private mapService: MapService) {}

  get isMobile(): boolean {
    return this.mapService.isMobile;
  }

  generatePlacemarksCenters(
    centers: CenterModel[],
    isHelixLite: boolean | null
  ): IPlacemarkCenter[] {
    return centers
      .filter(
        (centerInfo) =>
          centerInfo.geoLocationInfo &&
          centerInfo.geoLocationInfo.latitude !== 0 &&
          centerInfo.geoLocationInfo.longitude !== 0
      )
      .map((centerInfo) => {
        const balloonContent = `
        <div style="font-family: Golos;" class="px-8">
          <div class="typography typography-headline">
            ${centerInfo.name}
          </div>
          <div class="typography grey-800 my-8">
            ${centerInfo.address}
          </div>
          <a class="typography green-basic typography-underline"
             centerInfoCode=${centerInfo.code}
          >
            Подробная информация
          </a>
        </div>`;
        const placemarkOptions = isHelixLite
          ? placemarkCenterOptionsLite
          : placemarkCenterOptions;

        return {
          geometry: [
            centerInfo.geoLocationInfo?.latitude ?? 0,
            centerInfo.geoLocationInfo?.longitude ?? 0,
          ],
          options: {
            ...placemarkOptions,
            hasBalloon: !this.isMobile,
          },
          properties: {
            clusterCaption: centerInfo.name,
            balloonContent,
          },
          centerInfo,
          selected: false,
        } as IPlacemarkCenter;
      });
  }

  getCenterMap(placemarks: IPlacemarkCenter[]): number[] {
    return this.mapService.getCenterMap(
      placemarks,
      (placemark) => placemark.geometry
    );
  }

  getClustererOptions(ymaps: ymaps.IClustererOptions): ymaps.IClustererOptions {
    return this.mapService.getClustererOptions(ymaps);
  }
}
